// Copyright (c) 2017 Deere & Company

import ClaimTypes, {getDefaultState as getClaimTypesDefaultState} from '../../shared/state/claim-types';
import actions from '../../shared/actions-list';

const updateClaimTypes = (state, action) =>
    ClaimTypes.update(state, {
        $set: action.data
    });

export default (state = getClaimTypesDefaultState(), action) => {

    const actionTypes = {
        [actions.UPDATE_CLAIM_TYPES]: updateClaimTypes
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/app/reducers/claim-types.js